export interface CoreVersion {
  version: string;
  releaseDate?: string;
  changes: string[];
}

export const CORE_VERSIONS: CoreVersion[] = [
  {
    version: '2.27',
    releaseDate: '2025-12-01',
    changes: ['Versión inicial registrada del CORE de SynerLab.'],
  },
  {
    version: '3.0',
    releaseDate: '2026-04-26',
    changes: [
      '**Módulo de Control de Calidad**: nuevo módulo para creación de materiales, lotes y controles por niveles, registro de resultados, gráficos Levey-Jennings, reglas de Westgard y Six Sigma básico.',
      '**Impresión y envío masivo de resultados**: se habilitan los servicios para procesar la impresión y el envío masivo de resultados.',
      '**Envío masivo de resultados por correo y WhatsApp**: se habilita el procesamiento automático y manual.',
      '**Envío de resultados a laboratorios de referencia**: se habilita la comunicación con laboratorios externos que también usan SynerLab a través del módulo de remisiones externas.',
      '**Inicio de sesión más seguro**: se incorpora la verificación reCAPTCHA durante la autenticación.',
      '**Registro de IPs de confianza**: se incorpora un registro de direcciones autorizadas para que los equipos dentro de la institución no requieran la verificación reCAPTCHA al iniciar sesión.',
      '**Mantenimientos sin limpiar caché**: al crear, modificar o eliminar elementos en el módulo de Mantenimientos ya no es necesario limpiar la caché — basta con cerrar sesión y volver a entrar.',
      '**Facturación electrónica y RIPS**: se corrigen problemas de cálculo de totales con decimales.',
      '**Nuevos filtros en preórdenes**: se habilita la búsqueda por contrato, facturado y RIPS.',
      '**Control de duplicidad de órdenes**: se evita que se generen órdenes duplicadas cuando provienen de fuentes externas como HIS o LIS.',
      '**Interfaces de analizadores ampliadas**: ahora son compatibles con analitos de tipo Plantillas y Microbiología.',
      '**Resultados de imágenes DICOM**: se habilita el nuevo tipo de resultado ImágenesDX para almacenar y visualizar imágenes en formato DICOM, principalmente de rayos X.',
    ],
  },
  {
    version: '3.1',
    releaseDate: '2026-05-15',
    changes: ['**Citas:** Se implementa notificaciones por correo para nuevas citas.'],
  },
  {
    version: '3.2',
    releaseDate: '2026-05-21',
    changes: ['**Remisiones externas**: Se implementa devolución de resultados a laboratorios de referencia que también usan SynerLab.', '**Resultados:** Mejorar rendimiento en la interacción de resultados.'],
  },
  {
    version: '3.3',
    releaseDate: '2026-05-22',
    changes: ['**Remisiones externas**: Correcciones generales al módulo', '**órdenes**: Se implementa consecutivo manual para las órdenes, quedando así la opción de poder usar el consecutivo automático o manual según la necesidad de cada laboratorio.', '**Microbiología**: Correcciones generales al módulo de microbiología.'],
  },
  {
    version: '3.4',
    releaseDate: '2026-05-27',
    changes: [
      '**Preórdenes**: Se corrige que no quedaba registrado el laboratorio de referencia al crear una orden desde una preorden.',
      '**Órdenes y Preórdenes**: Ahora se pueden modificar preórdenes que ya tienen una orden asociada. Para ello, modifique siempre la preorden; tenga en cuenta que no puede estar procesada, liquidada, facturada ni enviada a los RIPS.',
      '**Caja**: Se habilita el servicio para liquidar órdenes de forma masiva, aplicando una misma forma de pago y una nota opcional a todas las órdenes seleccionadas.',
      '**Ordenes y búsquedas masivas**: Se mejora el filtro por órdenes desde - hasta.',
      '**FEV + RIPS**: Cambios para resolución 948 del 2026.',
    ],
  },
  {
    version: '3.7',
    releaseDate: '2026-07-29',
    changes: [
      '**Tableros BI**: se habilitan los servicios que entregan los tableros de inteligencia de negocios a la aplicación web, incluyendo la consulta de datos y la exportación a PDF, Excel e imagen.',
      '**Tableros BI**: el acceso exige sesión válida y cada usuario solo recibe los tableros habilitados para su perfil.',
      '**Tableros BI**: los datos siempre se consultan contra la base de datos del propio servidor, sin importar con qué base se diseñó el tablero. Las credenciales de conexión nunca se envían al navegador.',
    ],
  },
];
